import {
    HomeView,
    UnauthorizedView,
    PageNotFoundView,
    EventosView,
    AlertasView,
    IncidenciasView,
    EventoView,
    AlertaView,
    IncidenciaView,
} from '../views';
import { TIPS } from '../consts/tips';

export const PrivateRoutes = [
  {
    index: 0,
    code: "home",
    path: "/",
    component: HomeView,
    title: "Home",
    showHeader: true,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.HOME_VIEW
  },
  {
    index: 5,
    code: "unauthorized",
    path: "/unauthorized",
    component: UnauthorizedView,
    title: "Unauthorized",
    showHeader: false,
    nivelMenu: 0,
    children: []
  },
//not-found
  {
    index: 999,
    code: "not-found",
    path: "*",
    component: PageNotFoundView,
    title: "Página no encontrada",
    showHeader: false,
    nivelMenu: 0,
    children: [],
    tipName: TIPS.NAME.ROUTES.NOT_FOUND
  },
  {
    index: 11,
    code: "auditoria_view",
    path: "/eventos",
    component: EventosView,
    title: "Eventos",
    showHeader: true,
    nivelMenu: 1,
    children: [],
    tipName: TIPS.NAME.ROUTES.EVENTOS_VIEW
  },
  {
    index: 12,
    code: "auditoria_view",
    path: "/evento/:id",
    component: EventoView,
    title: "Evento",
    showHeader: false,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.EVENTO_VIEW
  },
  {
    index: 13,
    code: "auditoria_view",
    path: "/alertas",
    component: AlertasView,
    title: "Alertas",
    showHeader: true,
    nivelMenu: 1,
    children: [],
    tipName: TIPS.NAME.ROUTES.ALERTAS_VIEW
  },
  {
    index: 14,
    code: "auditoria_view",
    path: "/alerta/:id",
    component: AlertaView,
    title: "Alerta",
    showHeader: false,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.ALERTA_VIEW
  },
  {
    index: 15,
    code: "auditoria_view",
    path: "/incidencias",
    component: IncidenciasView,
    title: "Incidencias",
    showHeader: true,
    nivelMenu: 1,
    children: [],
    tipName: TIPS.NAME.ROUTES.INCIDENCIAS_VIEW
  },
  {
    index: 16,
    code: "auditoria_view",
    path: "/incidencia/:id",
    component: IncidenciaView,
    title: "Incidencia",
    showHeader: false,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.INCIDENCIA_VIEW
  },
];
